import { Encoder } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { MoveCoord } from '../../jscaip/MoveCoord';
import { QuartoPiece } from './QuartoPiece';
export class QuartoMove extends MoveCoord {
    piece;
    static encoder = Encoder.tuple([Coord.encoder, QuartoPiece.encoder], (m) => [m.coord, m.piece], (fields) => new QuartoMove(fields[0].x, fields[0].y, fields[1]));
    constructor(x, y, piece) {
        /* (x, y) is the coord where you put the 'inHand' quarto piece
         * piece is the quarto piece you give
         */
        super(x, y);
        this.piece = piece;
    }
    toString() {
        return 'QuartoMove(' + this.coord.x + ', ' +
            this.coord.y + ', ' +
            this.piece.value +
            ')';
    }
    equals(other) {
        if (this === other)
            return true;
        if (other.coord.equals(this.coord) === false)
            return false;
        return this.piece === other.piece;
    }
}
